import Alert from '@/assets/icons/Alert';

import styles from './SearchInputError.module.css';

const SearchInputError = ({ errorText, smallGap = false }) => (
  <div className={[styles.fieldError, smallGap ? styles.smallGap : ''].join(' ')}>
    <Alert className={styles.fieldErrorIcon} />
    <span>{errorText}</span>
  </div>
);
export default SearchInputError;
